<template>
  <SoButton
    title="Delete User"
    type="danger"
    data-testid="user-delete-btn"
    large
    @click="openDeleteDialog"
  />
  <UserDeleteModal v-model="userDeleteModalOpen" />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import UserDeleteModal from "@/views/admin/users/components/UserDeleteModal.vue"

  export default defineComponent({
    components: {
      UserDeleteModal,
      SoButton,
    },
    data() {
      return {
        userDeleteModalOpen: false,
      }
    },
    methods: {
      openDeleteDialog() {
        this.userDeleteModalOpen = true
      },
    },
  })
</script>
